export async function downloadVirtualTerminalPoster() {
  const response = await fetch('/api/virtual-terminal/my-terminal/poster.jpg', {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    let message = 'Failed to download terminal banner';
    try {
      const data = await response.json();
      message = data.error || message;
    } catch {
      // PDF endpoint may return plain text/html on proxy failures.
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  const disposition = response.headers.get('content-disposition') || '';
  const match = disposition.match(/filename="?([^"]+)"?/i);
  const filename = match?.[1] || 'paystack-terminal-banner.jpg';
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
